import { Avatar, Box, Typography } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import React from "react";
import { InfoTooltip } from "../../consts";
import { THEME_MODES } from "../../helpers/constant";

const InfoCardBox = ({
  colours,
  themeMode,
  icon = "info",
  iconBg,
  backgroundColor,
  borderColor,
  title = "Title",
  tooltip = "",
  value = 0,
  customAvatar = null,
  customValue = null,
  customStyle = {},
}) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      gap={1}
      alignItems="center"
      padding={2}
      sx={{
        backgroundColor: backgroundColor,
        border: `1px solid ${borderColor}`,
        borderRadius: 2,
        ...customStyle,
      }}
    >
      {customAvatar ?? (
        <Avatar sx={(theme)=>({ bgcolor: iconBg, color: theme.palette.mode === THEME_MODES.LIGHT ?  colours.white : colours.black })}>
          <FeatherIcon icon={icon} size={20} />
        </Avatar>
      )}

      <Box display="flex" flexDirection="column">
        <Typography variant="caption" display="inline-flex" alignItems="center" gap={0.5}>
          {title}
          {tooltip && <InfoTooltip iconSize={16} info={tooltip} themeMode={themeMode} />}
        </Typography>
        {customValue ?? (
          <Typography variant="h5" component="div" fontWeight={600}>
            {value}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default InfoCardBox;